import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, computed, inject } from '@angular/core';
import { PM_SHELL_QUICK_ADD_HOST, type PmShellQuickAddHost } from './pm-shell-quick-add-host';

/** Quick Add popup (top bar + button / Ctrl K): searchable list of create actions (client, contact, task, deadline, meeting and so on). */
@Component({
  selector: 'pm-shell-quick-add',
  standalone: true,
  imports: [],
  templateUrl: './pm-shell-quick-add.component.html',
  styleUrl: './pm-shell-quick-add.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PmShellQuickAddComponent {
  /** Read by the workspace, which focuses it when Quick Add opens. */
  @ViewChild('qaSearchInput') qaSearchInput?: ElementRef<HTMLInputElement>;

  /** What this section still reads from the workspace (see pm-shell-quick-add-host.ts). */
  private readonly workspace = inject(PM_SHELL_QUICK_ADD_HOST);

  get activeQaIndex() {
    return this.workspace.activeQaIndex;
  }

  applyCustomLabels(...args: Parameters<PmShellQuickAddHost['applyCustomLabels']>): ReturnType<PmShellQuickAddHost['applyCustomLabels']> {
    return this.workspace.applyCustomLabels(...args);
  }

  executeQuickAction(...args: Parameters<PmShellQuickAddHost['executeQuickAction']>): ReturnType<PmShellQuickAddHost['executeQuickAction']> {
    return this.workspace.executeQuickAction(...args);
  }

  getCustomLabel(...args: Parameters<PmShellQuickAddHost['getCustomLabel']>): ReturnType<PmShellQuickAddHost['getCustomLabel']> {
    return this.workspace.getCustomLabel(...args);
  }

  get isQuickAddOpen() {
    return this.workspace.isQuickAddOpen;
  }

  get quickAddQuery() {
    return this.workspace.quickAddQuery;
  }

  get quickAddVisibleIndices() {
    return this.workspace.quickAddVisibleIndices;
  }

  stopProp(...args: Parameters<PmShellQuickAddHost['stopProp']>): ReturnType<PmShellQuickAddHost['stopProp']> {
    return this.workspace.stopProp(...args);
  }

  readonly quickAddVisibleCount = computed(() => this.quickAddVisibleIndices().length);

  isQuickAddItemVisible(index: number): boolean {
    return this.quickAddVisibleIndices().includes(index);
  }

  onQuickAddSearchInput(value: string): void {
    this.quickAddQuery.set(value);
    const vis = this.quickAddVisibleIndices();
    if (vis.length > 0) {
      this.activeQaIndex.set(vis[0]!);
    }
  }
}
